import {
  DEVELOPER_API_URL,
  DEVELOPERAPP_API_URL,
  DEVELOPERAPP_API_URL_SUB_ADD,
  DEVELOPERAPP_API_URL_SUB_REMOVE,
  SUBSCRIPTION_API_URL
} from '@/services/constants';
import axiosClient from '../axiosClient';

const Devportal = {
  fetchDeveloper: async (params: any) => {
    const response = await axiosClient.get(`${DEVELOPER_API_URL}`, {
      params
    });
    return response.data;
  },
  fetchApiDetails: async (id: any) => {
    const response = await axiosClient.get(`${DEVELOPER_API_URL}/${id}`);
    return response.data;
  },
  fetchDeveloperApp: async (params: any) => {
    const response = await axiosClient.get(`${DEVELOPERAPP_API_URL}/applications`, {
      params
    });
    return response.data;
  },
  mappingAddDevportal: async (body: any) => {
    const response = await axiosClient.post(`${DEVELOPERAPP_API_URL_SUB_ADD}`, body);
    return response.data;
  },
  mappingRemoveDevportal: async (body: any) => {
    const response = await axiosClient.post(`${DEVELOPERAPP_API_URL_SUB_REMOVE}`, body);
    return response.data;
  },
  subscriptionApi: async (body: any, action: 'string') => {
    const response = await axiosClient.post(`${SUBSCRIPTION_API_URL}/${action}`, { ...body });
    return response.data;
  }
};

export default Devportal;
